import React, { FC, SyntheticEvent, useEffect } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { StyledTab, StyledTabs } from "./styled";
import { StudioDetailsTabs } from "entities/studios/types";
import { useStudioDetails } from "../../context";
import useRolePermission from "entities/auth/hooks/useRolePermission";

const Tabs: FC = () => {
  const { selectedTab, setSelectedTab } = useStudioDetails();
  const { allowed: hasReadAccess } = useRolePermission("studios:read");
  const { allowed: hasReadTranslationsAccess } = useRolePermission("studios:translations:read");

  const shouldRenderGeneralTab = hasReadAccess;
  const shouldRenderTranslationsTab = hasReadAccess || hasReadTranslationsAccess;

  const handleTabChange = (_: SyntheticEvent, newTab: StudioDetailsTabs) => {
    setSelectedTab(newTab);
  };

  useEffect(() => {
    return () => {
      setSelectedTab(StudioDetailsTabs.General);
    };
  }, [setSelectedTab]);

  return (
    <StyledTabs
      value={selectedTab}
      onChange={handleTabChange}
      TabIndicatorProps={{
        style: {
          backgroundColor: COLOR_PRIMARY_MAIN,
          height: 2,
        },
      }}
    >
      {shouldRenderGeneralTab && (
        <StyledTab
          id="page-tab-general"
          aria-controls="module-tabpanel-general"
          value={StudioDetailsTabs.General}
          disableRipple
          label="General"
        />
      )}
      {shouldRenderTranslationsTab && (
        <StyledTab
          id="page-tab-translations"
          aria-controls="module-tabpanel-translations"
          value={StudioDetailsTabs.Translations}
          disableRipple
          label="Translations"
        />
      )}
    </StyledTabs>
  );
};

export default Tabs;
